// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"efd6bc60","455":"245309b2","977":"8689fef8"}[chunkId] + ".chunk.js";
};